<template>
  <div>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition> 
    <Links />
  </div>
</template>

<script>
import Links from "@/components/Links"
export default {
  components:{
    Links
  },
  mounted(){
    this.$store.commit('changeview', 'dashboard')
  }
}
</script>

<style scoped>
input::placeholder{
  color: #697386
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>